import { render, staticRenderFns } from "./blood-oxygen-report-preview-dialog.vue?vue&type=template&id=6e70d70e&scoped=true"
import script from "./blood-oxygen-report-preview-dialog.vue?vue&type=script&lang=js"
export * from "./blood-oxygen-report-preview-dialog.vue?vue&type=script&lang=js"
import style0 from "./blood-oxygen-report-preview-dialog.vue?vue&type=style&index=0&id=6e70d70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e70d70e",
  null
  
)

export default component.exports